/**
 * TODO: This need refactoring and rationalised. Changes throughout
 * TODO: development lead to 3 versions of this which should be combined
 * TODO: into a single component
 * @see IngredientForm,
 * @see IngredientProductForm
 * @see LinkIngredientsToProductModal
 */

import { Formik, useFormikContext } from 'formik'
import React, { useEffect } from 'react'
import * as Yup from 'yup'

import {
  Button,
  Form,
  FIELD_REQUIRED,
  FormikTextField,
  FormikRadioGroup,
} from 'src/modules/ui'

import { useActionRunner } from 'src/modules/notification'
import { Box, Grid, InputAdornment, Typography } from '@material-ui/core'
import { usePurchasing } from '../../../purchasing'
import { isEmpty, uniqBy } from 'lodash'
import IngredientProductForm from './IngredientProductForm'
import IngredientProductList from '../IngredientProductsList'
import { useRecipes } from '../../hooks'
import { Skeleton } from '@material-ui/lab'

const IngredientForm = ({ onSubmit, editData }) => {
  const { purchasingEnvironments } = usePurchasing()
  const { fetchAgreedSuppliers, agreedSuppliers, fromRecipeId } = useRecipes()

  const [latestSelectedProduct, setLatestSelectedProduct] = React.useState(null)
  const [latestSelectedSupplier, setLatestSelectedSupplier] = React.useState(
    null
  )
  const [selectedProducts, setSelectedProducts] = React.useState([])

  const [formValues, setFormValues] = React.useState({})
  const [canSubmit, setCanSubmit] = React.useState(false)
  const [isTouched, setIsTouched] = React.useState(false)
  const formRef = React.useRef()

  // Overloading to fix an edit but - if initialData is undefined then this is a create
  const isCreate = editData === undefined ? true : false

  const [fetchData, isFetching] = useActionRunner(
    [() => fetchAgreedSuppliers({ page: 1, total: 999 })],

    {
      initialFetchingState: true,
    }
  )

  const updateAggreementProducts = () => {
    if (editData) {
      setSelectedProducts(editData.agreementProducts)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    updateAggreementProducts()
  }, [editData, fromRecipeId])

  /**
   * Handle form changes with formik managed values and externally managed values.
   *
   * @returns
   */
  const FormObserver = () => {
    const { values, errors, touched, isSubmitting } = useFormikContext()
    const isTouched = Object.values(touched).some(Boolean)
    const hasSelectedProducts = selectedProducts.length > 0
    const isValid = isEmpty(errors)

    useEffect(() => {
      setFormValues(values)
      setIsTouched(isTouched)
      if (
        isTouched &&
        isValid &&
        (hasSelectedProducts ||
          (values.externalProductName && values.externalProductPrice))
      ) {
        setCanSubmit(true)
      } else if (!isTouched && editData !== undefined) {
        setCanSubmit(true)
      } else {
        setCanSubmit(false)
      }
    }, [values, errors, isTouched, hasSelectedProducts, isValid, isSubmitting])

    return null
  }

  const handleSubmit = async () => {
    onSubmit({ ...formValues, products: selectedProducts })
  }

  const handleAddProduct = () => {
    setSelectedProducts(
      uniqBy([...selectedProducts, latestSelectedProduct], 'id')
    )
    setLatestSelectedProduct(null)
    formRef.current.reset()
  }

  const handleRemoveProduct = id => {
    console.log('handleRemoveProduct 2')
    console.log(selectedProducts)
    console.log(
      id,
      selectedProducts.filter(p => p.id !== id)
    )
    setSelectedProducts(selectedProducts.filter(p => p.product.id !== id))
  }

  const isTainted = () => {
    if (
      (editData && editData.agreementProducts !== selectedProducts) ||
      (editData && isTouched)
    ) {
      return true
    }
    return false
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required(FIELD_REQUIRED)
      .min(3, 'Must be at least three characters'),
    description: Yup.string(),
  })

  return (
    <>
      <Formik
        initialValues={{
          name: !isCreate && editData ? editData.name : '',
          unit: !isCreate && editData ? editData.unit : 'g',
          externalProductName:
            !isCreate && editData
              ? editData.externalProduct
                ? editData.externalProduct.name
                : ''
              : '',
          externalProductPrice:
            !isCreate && editData
              ? editData.externalProduct
                ? editData.externalProduct.price
                : ''
              : '',
        }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {() => (
          <>
            <Form>
              <FormObserver />
              <Form.InputGroup title="Ingredient">
                {isCreate || editData ? (
                  <FormikTextField
                    label="Ingredient Name"
                    margin="normal"
                    name="name"
                    fullWidth
                  />
                ) : (
                  <Skeleton
                    variant="rect"
                    height={55}
                    style={{
                      borderRadius: 10,
                      marginTop: 10,
                      marginBottom: 9,
                    }}
                  />
                )}
                {isCreate || editData ? (
                  <FormikRadioGroup
                    fullWidth
                    key="unit"
                    label="Unit"
                    margin="normal"
                    name="unit"
                    options={[
                      { value: 'g', label: 'grams' },
                      { value: 'ml', label: 'ml' },
                    ]}
                    table={true}
                  />
                ) : (
                  <Skeleton
                    variant="rect"
                    height={35}
                    style={{
                      borderRadius: 10,
                      marginTop: 10,
                      marginBottom: 9,
                    }}
                  />
                )}
              </Form.InputGroup>

              <Form.InputGroup title="Supplier Products">
                <Typography variant="body2">
                  To calculate price, nutritional info etc.. link to the
                  supplier product you're using for this ingredient. We will use
                  the first ingredient available in the environment.
                </Typography>

                <div style={{ height: '2rem' }} />

                {isCreate || editData ? (
                  <IngredientProductList
                    products={selectedProducts}
                    onRemove={handleRemoveProduct}
                    supplier={latestSelectedSupplier}
                  />
                ) : (
                  <Skeleton
                    variant="rect"
                    height={55}
                    style={{
                      borderRadius: 10,
                      marginTop: 10,
                      marginBottom: 9,
                    }}
                  />
                )}

                <div style={{ height: '2rem' }} />

                <IngredientProductForm
                  purchasingEnvironments={purchasingEnvironments}
                  suppliers={agreedSuppliers}
                  isFetchingSuppliers={isFetching}
                  onSelectProduct={({ supplier, product }) => {
                    setLatestSelectedProduct(product)
                    setLatestSelectedSupplier(supplier)
                  }}
                  ref={formRef}
                />

                <div style={{ height: '1rem' }} />

                <Button
                  color="primary"
                  onClick={handleAddProduct}
                  size="large"
                  disabled={latestSelectedProduct === null}
                >
                  Add Product
                </Button>
              </Form.InputGroup>

              <div style={{ marginTop: '2rem' }} />

              <Form.InputGroup title="External Product">
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    {isCreate || editData ? (
                      <FormikTextField
                        label="Product Name"
                        margin="normal"
                        name="externalProductName"
                        fullWidth
                      />
                    ) : (
                      <Skeleton
                        variant="rect"
                        height={55}
                        style={{
                          borderRadius: 10,
                          marginTop: 10,
                          marginBottom: 9,
                        }}
                      />
                    )}
                  </Grid>

                  <Grid item md={6} xs={12}>
                    {isCreate || editData ? (
                      <FormikTextField
                        label=""
                        margin="normal"
                        name="externalProductPrice"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              style={{ marginTop: '0' }}
                            >
                              £
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              per g
                            </InputAdornment>
                          ),
                        }}
                      />
                    ) : (
                      <Skeleton
                        variant="rect"
                        height={55}
                        style={{
                          borderRadius: 10,
                          marginTop: 10,
                          marginBottom: 9,
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Form.InputGroup>
              <Box display="flex" alignItems="center">
                <Button
                  color="primary"
                  onClick={handleSubmit}
                  size="large"
                  disabled={!canSubmit}
                >
                  Save
                </Button>
                {isTainted() ? (
                  <Typography style={{ marginLeft: '1rem' }} color="secondary">
                    <b>You have unsaved changes.</b>
                  </Typography>
                ) : null}
              </Box>
            </Form>
          </>
        )}
      </Formik>
    </>
  )
}

export default IngredientForm
